import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.element.querySelectorAll('.datepicker').forEach(el => {
      flatpickr(el, { dateFormat: "m/d/Y", now: today });
    });
    this.element.querySelectorAll('.datepicker-current').forEach(el => {
      flatpickr(el, { dateFormat: "m/d/Y", now: today, defaultDate: new Date(Date.now() + 5 * 24*60*60*1000) });
    });
    this.element.querySelectorAll('.runtime').forEach(el => {
      flatpickr(el, { enableTime: true, noCalendar: true, dateFormat: "H:i" });
    });
  }
}
